import React from 'react';
import '../styles/ServiceDetails.css';

function ServiceProjectManagement() {
  return (
    <div className="page">
      <section className="hero">
        <div className="hero-inner">
          <h1 className="title">Διοίκηση &amp; Διαχείριση Τεχνικών Έργων</h1>
          <p className="subtitle">Project &amp; Construction Management</p>
        </div>
      </section>

      <section className="intro">
        <div className="wrap">
          <p>
            Η ΚΑΡΤΕΡΙΑ Κατασκευαστική &amp; Συμβουλευτική παρέχει ολοκληρωμένες υπηρεσίες
            διοίκησης και διαχείρισης τεχνικών έργων, καλύπτοντας το σύνολο των διαδικασιών
            Project &amp; Construction Management σε όλα τα στάδια του κύκλου ζωής του έργου.
          </p>
          <p>
            Η διοίκηση του έργου αντιμετωπίζεται ως ενιαία και ολοκληρωμένη διαδικασία, η
            οποία περιλαμβάνει τον σχεδιασμό, τον έλεγχο και την παρακολούθηση της
            κατασκευής, τη διαχείριση χρόνου και κόστους, καθώς και τη θεσμικά τεκμηριωμένη
            λήψη αποφάσεων. Η προσέγγιση αυτή διασφαλίζει τη συνέχεια και τη συνέπεια
            μεταξύ μελέτης, υλοποίησης και παράδοσης.
          </p>
        </div>
      </section>

      <section className="services">
        <div className="wrap">
          <h2 className="heading">Αντικείμενο Υπηρεσιών</h2>
          <p className="lead">
            Οι υπηρεσίες διοίκησης και διαχείρισης τεχνικών έργων περιλαμβάνουν:
          </p>
          <ul className="list">
            <li>Διοίκηση και συντονισμό του έργου σε επίπεδο Project &amp; Construction Management</li>
            <li>Σχεδιασμό, έλεγχο και παρακολούθηση της κατασκευαστικής διαδικασίας</li>
            <li>Παρακολούθηση της ορθής και εμπρόθεσμης εκτέλεσης του έργου σύμφωνα με την εγκεκριμένη μελέτη και τις εγκεκριμένες τροποποιήσεις της</li>
            <li>Σχεδιασμό, παρακολούθηση και έλεγχο του χρονοδιαγράμματος υλοποίησης</li>
            <li>Συνεχή παρακολούθηση της προόδου του έργου σε σχέση με το φυσικό και οικονομικό αντικείμενο</li>
            <li>Έλεγχο επιμετρήσεων και πιστοποιήσεων του Αναδόχου και των υπεργολάβων</li>
            <li>Υποστήριξη στη σύνταξη Ανακεφαλαιωτικών Πινάκων Εργασιών (ΑΠΕ) και τυχόν Συμπληρωματικών Συμβάσεων Εργασιών (ΣΣΕ)</li>
            <li>Συντονισμό όλων των εμπλεκόμενων μερών (μελετητές, ανάδοχο, υπεργολάβους, προμηθευτές)</li>
            <li>Υποστήριξη του Κυρίου του Έργου στη διαχείριση τεχνικών, χρονικών και οικονομικών ζητημάτων</li>
          </ul>
          <p className="note">
            Η παρακολούθηση του έργου πραγματοποιείται με συστηματικό τρόπο, ώστε να
            εντοπίζονται έγκαιρα αποκλίσεις και να λαμβάνονται τεκμηριωμένες και θεσμικά
            ορθές αποφάσεις.
          </p>
        </div>
      </section>

     
      <section className="highlights">
        <div className="wrap">
          <div className="highlights-block">
            <h2 className="heading">Ποιότητα Έργου, Commissioning &amp; Λειτουργική Παράδοση</h2>
            <div className="highlights-text highlights-paragraphs">
              <p>
                Στο πλαίσιο της διοίκησης και διαχείρισης των τεχνικών έργων καταρτίζεται, εφαρμόζεται και παρακολουθείται <strong>Πρόγραμμα Ποιότητας Έργου</strong>, σύμφωνα με τις κατευθυντήριες οδηγίες του <strong>ISO 10005:2018</strong>.
              </p>
              <p>
                Το <strong>Πρόγραμμα Ποιότητας Έργου</strong> βασίζεται στα πρότυπα <strong>ISO 9001</strong> (Συστήματα Διαχείρισης Ποιότητας) και <strong>ISO 14001</strong> (Συστήματα Περιβαλλοντικής Διαχείρισης). Οργανώνονται οι διαδικασίες ελέγχου, οι αρμοδιότητες και η τεχνική τεκμηρίωση, διασφαλίζοντας τη συμμόρφωση με όλες τις συμβατικές, ποιοτικές, περιβαλλοντικές και κανονιστικές απαιτήσεις.
              </p>
              <p>
                Η διοίκηση των τεχνικών έργων ακολουθεί σύγχρονες αρχές <strong>Project Management</strong> και τις κατευθυντήριες οδηγίες του <strong>ISO 21502:2020</strong>, διασφαλίζοντας αποτελεσματικό σχεδιασμό, συντονισμό και έγκαιρη ολοκλήρωση κάθε έργου.
              </p>
              <p>
                Παράλληλα, ενσωματώνεται οργανωμένη προσέγγιση σε θέματα <strong>Υγείας &amp; Ασφάλειας στην Εργασία</strong>, με συστηματική εκτίμηση κινδύνων και εφαρμογή προληπτικών μέτρων, σύμφωνα με το <strong>ISO 45001:2018</strong> και την ισχύουσα εθνική νομοθεσία.
              </p>
              <p>
                Σε έργα με αυξημένες απαιτήσεις λειτουργικής απόδοσης και βιωσιμότητας, παρέχεται υποστήριξη για <strong>λειτουργική παραλαβή συστημάτων (Commissioning)</strong> και κατάρτιση <strong>Προγράμματος Λειτουργίας &amp; Συντήρησης</strong>, σύμφωνα με τις απαιτήσεις του προτύπου <strong>LEED</strong> (Leadership in Energy and Environmental Design).
              </p>
            </div>
            <div className="iso-row">
              <div className="iso-card simple">
                <p className="badge">ISO 9001</p>
                <p>Ποιότητα</p>
              </div>
              <div className="iso-card simple">
                <p className="badge">ISO 14001</p>
                <p>Περιβάλλον</p>
              </div>
              <div className="iso-card simple">
                <p className="badge">ISO 21502</p>
                <p>Project Management</p>
              </div>
              <div className="iso-card simple">
                <p className="badge">ISO 45001</p>
                <p>Υγεία &amp; Ασφάλεια</p>
              </div>
              <div className="iso-card simple">
                <p className="badge">LEED</p>
                <p>Commissioning</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="legal">
        <div className="wrap">
          <h2 className="heading">Θεσμικό &amp; Κανονιστικό Πλαίσιο</h2>
          <p>
            Η διοίκηση και διαχείριση τεχνικών έργων πραγματοποιείται σε πλήρη συμμόρφωση
            με το ισχύον θεσμικό πλαίσιο δημοσίων έργων και συμβάσεων.
          </p>
          <ul className="list list-legal">
            <li>
              <strong>Ν. 4412/2016</strong> — καθορίζει τις διαδικασίες ανάθεσης, τις
              συμβατικές υποχρεώσεις, καθώς και τους μηχανισμούς ελέγχου, πιστοποίησης και
              παραλαβής του φυσικού και οικονομικού αντικειμένου για δημόσια και
              συγχρηματοδοτούμενα έργα.
            </li>
            <li>
              <strong>ΕΤΕΠ</strong> (ΦΕΚ Β΄ 2221/30.07.2012) — Ελληνικές Τεχνικές
              Προδιαγραφές, σύμφωνα με τις οποίες πραγματοποιείται η εκτέλεση και
              παρακολούθηση των εργασιών, σε συνδυασμό με τα συμβατικά τεύχη και τις
              εγκεκριμένες μελέτες κάθε έργου.
            </li>
            <li>
              <strong>Π.Δ. 305/1996</strong> — διατάξεις για την Υγεία και Ασφάλεια στα
              εργοτάξια, όπως ισχύει.
            </li>
          </ul>
        </div>
      </section>

      <section className="approach">
        <div className="wrap">
          <h2 className="heading">Η Προσέγγισή μας</h2>
          <p>
            Η διοίκηση και διαχείριση τεχνικών έργων στην ΚΑΡΤΕΡΙΑ βασίζονται στη
            μεθοδικότητα, στη θεσμική γνώση και στη συστηματική τεχνική παρακολούθηση,
            διασφαλίζοντας ποιοτική, ασφαλή και αξιόπιστη υλοποίηση και παράδοση των έργων.
          </p>
        </div>
      </section>

    </div>
  );
}

export default ServiceProjectManagement;
